import * as React from 'react';
import SingleSPAParcel from 'single-spa-react/parcel';
import { Inject } from '@symbiotic/green-state';
import { Lifecycles } from './PortalPlugin';
import { PortalFramework } from './PortalFramework';

export const Parcel = ({ config }: { config: Lifecycles }) => (
  <Inject diKey={PortalFramework}>
    {(portalFramework: PortalFramework) => <SingleSPAParcel portalFramework={{ ...portalFramework }} config={config} />}
  </Inject>
);



// WEBPACK FOOTER //
// ./src/framework/Parcel.tsx